import { useState } from 'react'
import { Button } from 'antd'
import axios from 'axios'

// REDUX
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../redux/user/user.selectors'

// COMPONENT
import { message, Modal } from 'antd'

import './ButtonDelete.scss'
const ButtonDelete = ({
  endPoints = '',
  id = null,
  msgFail = 'Data Gagal Dihapus',
  title = 'Apakah kamu yakin untuk menghapus data ini ?',
}) => {
  const currentUser = useSelector(selectCurrentUser)
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const showModal = () => setOpen(true)

  const handleCancel = () => setOpen(false)

  const handleOk = () => {
    setLoading(true)
    axios({
      method: 'delete',
      url: `${endPoints}/${id}`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(() => {
        window.location.reload()
      })
      .catch((error) => {
        console.log(error)
        message.error(msgFail)
        setLoading(false)
      })
  }
  return (
    <>
      <Button className="ant-btn-red" onClick={showModal}>
        Hapus
      </Button>
      <Modal
        className="ant-modal-confirm"
        closable={false}
        width={400}
        centered
        visible={open}
        onOk={handleOk}
        confirmLoading={loading}
        onCancel={handleCancel}
        loading={loading}>
        <p>{title}</p>
      </Modal>
    </>
  )
}

export default ButtonDelete
